import { useCompany, useCompanyCanonicalUrl } from '@/hooks/useCompany';
import { PRIMARY_INDUSTRIES } from '@/constants/industries';
import {
  ROUTE_COMPANY,
  ROUTE_STOCKS_MARKET,
  ROUTE_STOCKS_MARKET_INDUSTRY,
} from '@/constants/routes';
import { useTranslation } from '@/hooks/useTranslation';

export function useBreadcrumbs() {
  const canonicalUrl = useCompanyCanonicalUrl();
  const { data: company, status } = useCompany(canonicalUrl);
  const t = useTranslation();

  if (status !== 'success') return { status };

  const {
    data: {
      name,
      unique_symbol: uniqueSymbol,
      info: {
        data: {
          industry: { primary_id: industryId },
        },
      },
    },
  } = company;

  const [_, stocks, market, industry, ticker, companyName] =
    company.data.canonical_url.split('/');

  const industrySlug =
    industryId !== null && typeof industryId !== 'undefined'
      ? PRIMARY_INDUSTRIES[
          industryId.toString() as keyof typeof PRIMARY_INDUSTRIES
        ]?.slug
      : null;

  const breadcrumbs = [
    {
      name: t('page.companyReport.header.stocks'),
      canonicalUrl: `/${stocks}/${market}`,
      dispatch: {
        type: ROUTE_STOCKS_MARKET,
        payload: {
          market: market,
        },
      },
    },
    ...(industrySlug
      ? [
          {
            name: t(`page.companyReport.header.industry.${industrySlug}`),
            canonicalUrl: `/${stocks}/${market}/${industry}`,
            dispatch: {
              type: ROUTE_STOCKS_MARKET_INDUSTRY,
              payload: {
                market: market || undefined,
                industry: industry || undefined,
              },
            },
          },
        ]
      : []),
    {
      name: `${name} ${uniqueSymbol}`,
      canonicalUrl,
      documentSchemaOnly: true,
      dispatch: {
        type: ROUTE_COMPANY,
        payload: {
          isoCode2: market || undefined,
          industry: industry || undefined,
          exchange_ticker: ticker || undefined,
          companyname: companyName || undefined,
        },
      },
    },
  ];
  return { status: 'success' as const, breadcrumbs };
}
